import { useI18n } from 'vue-i18n'

/**
 * По ТЗ 03.09.2026: справочники (Rank/Position/UserCategory/DutyType) отдают
 * `name`, `name_kk`, `name_ru`. Выбираем по текущей локали.
 * Fallback: name_ru → name → name_kk → пустая строка.
 */
export function localizedName(entity, locale) {
  if (!entity) return ''
  const kk = entity.name_kk
  const ru = entity.name_ru
  const base = entity.name
  if (locale === 'kz') return kk || base || ru || ''
  if (locale === 'ru') return ru || base || kk || ''
  return base || ru || kk || ''
}

/**
 * Vue-composable: возвращает функцию, которая берёт активную локаль
 * из vue-i18n автоматически.
 */
export function useLocalizedName() {
  const { locale } = useI18n()
  return (entity) => localizedName(entity, locale.value)
}
